// if (!customElements.get('product-modal')) {
//   customElements.define('product-modal', class ProductModal extends ModalDialog {
//     constructor() {
//       super();
//     }

//     hide() {
//       super.hide();
//     }

//     show(opener) {
//       super.show(opener);
//       this.showActiveMedia();
//     }

//     showActiveMedia() {
//       this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
//           element.classList.remove('active');
//         }
//       )
//       const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
//       const activeMediaTemplate = activeMedia.querySelector('template');
//       const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
//       activeMedia.classList.add('active');
//       activeMedia.scrollIntoView();

//       const container = this.querySelector('[role="document"]');
//       container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

//       if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
//         activeMedia.loadContent();
//     }
//   });
// }

if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
      this.pointerData = { x: 0, y: 0 };
      this.isClosing = false;
      // Cache các thành phần cố định để tránh truy vấn DOM lặp lại
      this.container = this.querySelector('[role="document"]');
    }

    connectedCallback() {
      // Đăng ký sự kiện một lần duy nhất khi element được render
      if (this.container) {
        this.container.addEventListener('pointerdown', this.onPointerDown.bind(this), { passive: true });
        this.container.addEventListener('pointerup', this.onPointerUp.bind(this));
      }
    }

    onPointerDown(e) {
      this.pointerData.x = e.clientX;
      this.pointerData.y = e.clientY;
    }

    onPointerUp(e) {
      if (this.isClosing || e.target.closest('button')) return;

      const diffX = Math.abs(e.clientX - this.pointerData.x);
      const diffY = Math.abs(e.clientY - this.pointerData.y);

      // Ngưỡng 10px để phân biệt click/drag
      if (diffX < 10 && diffY < 10) {
        this.hide();
      }
    }

    hide() {
      this.isClosing = true;
      super.hide();
      // Khóa trạng thái đóng lâu hơn một chút (400ms) để triệt tiêu hoàn toàn ghost click
      setTimeout(() => { this.isClosing = false; }, 400);
    }

    show(opener) {
      if (this.isClosing) return;
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      const openerId = this.openedBy?.getAttribute("data-media-id");
      if (!openerId) return;

      const medias = this.querySelectorAll('[data-media-id]');
      let activeMedia = null;

      // 1. Batch DOM updates: Duyệt một vòng duy nhất
      medias.forEach((media) => {
        const isActive = media.getAttribute('data-media-id') === openerId;
        media.classList.toggle('active', isActive);
        if (isActive) activeMedia = media;
      });

      if (!activeMedia || !this.container) return;

      // 2. Sử dụng requestAnimationFrame để tối ưu hóa render (tránh giật lag)
      requestAnimationFrame(() => {
        activeMedia.scrollIntoView({ block: 'nearest' });
        
        // Tính toán vị trí chính xác
        const scrollAmount = (activeMedia.offsetWidth - this.container.clientWidth) / 2;
        this.container.scrollLeft = scrollAmount;

        // 3. Lazy load media (Chỉ load khi thực sự cần)
        if (activeMedia.nodeName === 'DEFERRED-MEDIA') {
          const template = activeMedia.querySelector('template');
          if (template?.content.querySelector('.js-youtube')) {
            activeMedia.loadContent();
          }
        }
      });
    }
  });
}